export default "__VITE_ASSET__29509947__"